import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_360: DocMigration = {
  maxSchemaVersion: "0.0.360",
  description: "Replicates the state of showDormerWindowVerticalDimensions to showDormerWindowReportedName",
  apply(json: any) {
    for (const id in json.settings) {
      const setting = json.settings[id];
      if (setting.type === "PLAN_SETTINGS") {
        if (setting.showDormerWindowVerticalDimensions !== undefined) {
          setting.showDormerWindowReportedName = setting.showDormerWindowVerticalDimensions;
        }
      }
    }
    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const elevationSettings = roof.roofElevationPlanSettings;
      if (elevationSettings?.showDormerWindowVerticalDimensions !== undefined) {
        elevationSettings.showDormerWindowReportedName = elevationSettings.showDormerWindowVerticalDimensions;
      }
    }
    for (const id in json.dormers) {
      const dormer = json.dormers[id];
      const elevationSettings = dormer.dormerElevationPlanSettings;
      if (elevationSettings?.showDormerWindowVerticalDimensions !== undefined) {
        elevationSettings.showDormerWindowReportedName = elevationSettings.showDormerWindowVerticalDimensions;
      }
    }

    for (const id in json.settings) {
      const settings = json.settings[id];

      if (settings.type === "EXTERIOR_PROP_SETTINGS") {
        for (const settingsKey in settings.propTypes) {
          remapPropTypes(settings.propTypes[settingsKey]);
        }
      }

      if (settings.type === "INTERIOR_PROP_SETTINGS") {
        for (const settingsKey in settings.propTypes) {
          remapPropTypes(settings.propTypes[settingsKey]);
        }
      }
    }

    return json;
  },
};

export default migration_0_0_360;

function remapPropTypes(propTypes: Record<string, any>) {
  if (propTypes.floorPlanPrettyName !== undefined) {
    propTypes.floorPlanTag = propTypes.floorPlanPrettyName;
  }

  delete propTypes.floorPlanPrettyName;

  if (propTypes.planOffset !== undefined) {
    propTypes.floorPlanTagOffsetX = propTypes.planOffset;
  }

  delete propTypes.planOffset;
}
